import { Box, Button, makeStyles } from "@material-ui/core";
import React, { Fragment, useState } from "react";
import GreenTriangle from "../veggies/greenTriangle.png";
import WhiteTriangle from "../veggies/smwhitetriangle.png";
import DownArrow from "../veggies/downArrow.png";
// import veggiesData from "../veggies/VeggiesData";
import Stando from "../veggies/rightarrow.png";
// import ModalVeggiesData from "../veggies/ModalVeggiesData";
// import { SubItemsDisplay } from "./SubItemsDisplay";
import SimpleSubTitle from "./SimpleSubTitle";
import SubItemVariation from "./SubItemVariation";
const useStyles = makeStyles((theme) => ({
  mobileButton: {
    height: "80px",
    width: "100%",
    backgroundColor: "white",
  },
  mobileButtonActive: {
    height: "80px",
    width: "100%",
    backgroundColor: theme.palette.primary.main,
  },
  box: {
    marginBottom: "10px",
  },
  subButton: {
    height: "60px",
    width: "100%",
    marginBottom: "5px",
    fontWeight: "bold",
  },
  middle: {
    flexGrow: 1,
  },
  subItemGrid: {
    padding: "10px",
    width: "100%",
    height: "auto",
  },
}));
const ItemButton = ({ button, id, title, setButton, vegData }) => {
  const classes = useStyles();
  const contained = id === button ? "primary" : "default";
  return (
    <Box className={classes.box}>
      <Button
        variant="contained"
        color={contained}
        className={`${
          button === id ? classes.mobileButtonActive : classes.mobileButton
        }`}
        onClick={setButton}
      >
        {title}
        <div style={{ flexGrow: 1 }} />
        {id === button ? (
          <img src={WhiteTriangle} alt="white triangle" />
        ) : (
          <img src={GreenTriangle} alt="green tri" />
        )}
      </Button>
      {button === id ? (
        <SubMenu
          firstTitle={title === "野菜" ? true : false}
          vegData={vegData}
        />
      ) : (
        ""
      )}
    </Box>
  );
};

export default ItemButton;

const SubMenuButton = ({ title, subItem, onClick, id }) => {
  const classes = useStyles();

  return (
    <Button
      onClick={onClick}
      className={classes.subButton}
      variant="contained"
      color="secondary"
    >
      {title}
      <div className={classes.middle} />
      {id === subItem ? (
        <img src={DownArrow} alt="down arrow" />
      ) : (
        <img src={Stando} alt="enemy stand" />
      )}
    </Button>
  );
};

const SubMenu = ({ vegData, firstTitle }) => {
  const [subItem, setSubItem] = useState(0);
  const onSubItemSelection = (id) => {
    if (subItem === id) {
      setSubItem(0);
    } else {
      setSubItem(id);
    }
  };

  return (
    <Fragment>
      {vegData &&
        vegData.map((veg) => (
          <Fragment key={veg._id}>
            <SubMenuButton
              title={veg.title}
              subItem={subItem}
              onClick={() => onSubItemSelection(veg._id)}
              id={veg._id}
            ></SubMenuButton>
            {veg._id === subItem ? (
              <SubItemsDisplayGrid
                firstTitle={firstTitle}
                vegItems={veg.items}
                title={veg.title}
              />
            ) : (
              ""
            )}
          </Fragment>
        ))}
    </Fragment>
  );
};

const SubItemsDisplayGrid = ({ vegItems, firstTitle, title }) => {
  const classes = useStyles();
  return (
    <Box className={classes.subItemGrid}>
      {firstTitle ? (
        <SimpleSubTitle itemList={vegItems} />
      ) : (
        // <Grid container spacing={2}>
        //   {vegItems.map((item) => (
        //     <Grid item xs={6} key={item._id}>
        //       <SubItemsDisplay item={item} />
        //     </Grid>
        //   ))}
        // </Grid>
        <SubItemVariation title={title} subItem={vegItems} />
      )}
    </Box>
  );
};
